export default class RNFS {};
